import {useEffect,useId,useRef,useState} from 'react';
import {MOTION,usePrefersReducedMotion} from './motion.jsx';

/** Shared disclosure behavior for report filters and the embedded adapter.
 * Summary receives the panel ID. Selects may consume Escape before it reaches
 * this root. Hidden controls stay mounted and inert; opening pushes content. */
export function FilterDisclosure({expanded,onExpandedChange,summary,before,children,surface='collapsible',className,style}) {
  const id=useId(),root=useRef(null),clip=useRef(null),panel=useRef(null);
  const reduced=usePrefersReducedMotion(),previousExpanded=useRef(expanded);
  const [settled,setSettled]=useState(true);
  useEffect(()=>{
    if(reduced){setSettled(true);return;}
    setSettled(false);
    const timer=setTimeout(()=>setSettled(true),MOTION.durSlow+80);
    return()=>clearTimeout(timer);
  },[expanded,reduced]);
  useEffect(()=>{clip.current?.toggleAttribute('inert',!expanded)},[expanded]);
  useEffect(()=>{
    const opening=expanded&&!previousExpanded.current;
    previousExpanded.current=expanded;
    if(!opening)return;
    const raf=requestAnimationFrame(()=>panel.current?.querySelector('button,input,[tabindex]')?.focus({preventScroll:true}));
    return()=>cancelAnimationFrame(raf);
  },[expanded]);
  return <div ref={root} className={className} style={style} data-filter-surface={surface} onKeyDown={e=>{
    if(e.key==='Escape'&&expanded){e.stopPropagation();onExpandedChange(false);root.current?.querySelector('[aria-controls][aria-expanded]')?.focus();}
  }}>
    {before}{summary(id)}
    <div style={{display:'grid',gridTemplateRows:expanded?'1fr':'0fr',transition:reduced?undefined:`grid-template-rows ${MOTION.durSlow}ms ${MOTION.easeInOut}`}}
      onTransitionEnd={e=>{if(e.target===e.currentTarget&&e.propertyName==='grid-template-rows')setSettled(true)}}>
      <div ref={clip} style={{minHeight:0,overflow:expanded&&settled?'visible':'hidden'}}>
        <div id={id} ref={panel}>{children}</div>
      </div>
    </div>
  </div>;
}
